import RecordSummary from "./useritem/RecordSummary";

export default RecordSummary;
